import { ITableRow } from 'modules/admin-panel/pages/results/models';
import { STATISTIC_DATA_GLOBAL_NAME } from 'modules/admin-panel/pages/results/utils';

interface IRows extends Record<string, IRows | undefined> {}
interface INames extends Record<string, boolean> {}

export const getAllRowNames = (tableData?: ITableRow[]): IRows => {
	if (!tableData) return {};

	return tableData.reduce((res, { name: { value }, statistics }) => {
		if (value === STATISTIC_DATA_GLOBAL_NAME) return res;
		if (!statistics) {
			return {
				...res,
				[value]: undefined,
			};
		}
		return {
			...res,
			[value]: getAllRowNames(statistics),
		};
	}, {});
};

const getLocationObj = (locations: IRows | undefined): INames => {
	if (!locations) return {};
	return Object.entries(locations).reduce(
		(res, [key, obj]: [string, IRows | undefined]) => {
			const result = getLocationObj(obj);
			return {
				...res,
				...result,
				[key]: false,
			};
		},
		{},
	);
};

export const getRowsLocations = (names: IRows): any => {
	return Object.entries(names).reduce(
		(res, [key, obj]: [string, IRows | undefined]) => {
			if (!obj)
				return {
					...res,
					[key]: {},
				};

			const currentLocations = getLocationObj(obj);
			const rowsLocations = getRowsLocations(obj);

			return {
				...res,
				...rowsLocations,
				[key]: currentLocations,
			};
		},
		{},
	);
};
